module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-classic-1600.8a073ef9.svg";